import { RECEIVE_WORKOUTS } from '../constants/actionTypes';

export const initialWorkoutsState = {
  byID: {},
  all: [],
};

export default function workoutsReducer(state = initialWorkoutsState, action = {}) {
  switch (action.type) {
    case (RECEIVE_WORKOUTS): {
      return action.workouts.reduce((newState, currentWorkout) => {
        if (newState.byID[currentWorkout.workoutKey]) {
          newState.byID[currentWorkout.workoutKey] = { ...newState.byID[currentWorkout.workoutKey], ...currentWorkout }; // eslint-disable-line no-param-reassign
        } else {
          newState.byID[currentWorkout.workoutKey] = currentWorkout; // eslint-disable-line no-param-reassign
          newState.all = [currentWorkout.workoutKey, ...newState.all]; // eslint-disable-line no-param-reassign
        }
        return newState;
      }, { byID: { ...state.byID }, all: [...state.all] });
    }
    default:
      return state;
  }
}
